<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Create Fpv Reports</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="quarter"
                    :items="quarters"
                    item-text="name"
                    item-value="value"
                    :rules="requiredRule"
                    label="Quarter"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                >
                  <v-select
                    v-model="year"
                    :items="years"
                    item-text="name"
                    item-value="value"
                    :rules="requiredRule"
                    label="Year"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="error"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="createFpvReports"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'TriggerFpvReports',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      quarter: null,
      year: null,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  computed: {
    quarters() {
      return ['Q1', 'Q2', 'Q3', 'Q4'];
    },
    years() {
      return ['2022', '2023', '2024', '2025', '2026', '2027'];
    },
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.quarter = val.quarter;
      this.year = val.year;
    },
  },
  methods: {
    async createFpvReports() {
      if (this.$refs.form.validate()) {
        this.submitAction(this.generateParams(this.quarter, this.year));
      }
    },
    closeDialog() {
      this.cancelAction();
    },
    generateParams(quarter, year) {
      let begin = '';
      let end = '';
      switch (quarter) {
        case 'Q1':
          begin = '-01-01T00:00:01+01:00';
          end = '-03-31T23:59:59+01:00';
          break;
        case 'Q2':
          begin = '-04-01T00:00:01+01:00';
          end = '-06-30T23:59:59+01:00';
          break;
        case 'Q3':
          begin = '-07-01T00:00:01+01:00';
          end = '-09-30T23:59:59+01:00';
          break;
        case 'Q4':
          begin = '-10-01T00:00:01+01:00';
          end = '-12-31T23:59:59+01:00';
          break;
        default:
          return {
          };
      }

      return {
        documentType: 'fpv-report',
        identifiers: {
          periodBegin: year + begin,
          periodEnd: year + end,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .saldo-info {
    width: 90%;
    margin: 5px auto auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/roboInvesting/dialogs/TriggerFpvReports.vue